/** Visitor id is the chat widget's existing user id. The tracker never generates one. */

import { storage } from "@/utils";

export function visitorId(siteSlug: string): string | null {
  const id = storage.getUserId(siteSlug);
  return id || null;
}
